import './styles/index.css'

import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { initAuth } from './lib/auth'
import { registerAuthServiceWorker } from './lib/auth-service-worker'
import { cleanupStalePendingDownloads } from './lib/db'
import { setupPwaUpdate } from './lib/pwa-update'
import App from './pages/App.tsx'

/** 中断したまま再開されなかったダウンロードの中間データを掃除するまでの期間 */
const STALE_DOWNLOAD_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000

// React 19 開発モードの performance.measure() エントリ蓄積によるメモリリーク防止
// 本番ビルドでは logComponentRender 自体が除去されるため不要だが、dev では必須
if (import.meta.env.DEV) {
  performance.setResourceTimingBufferSize(50)
  // mark/measure エントリを定期クリア
  setInterval(() => {
    performance.clearMarks()
    performance.clearMeasures()
    performance.clearResourceTimings()
  }, 30_000)
}

// Sentry は本番ビルドのみ有効化（dev ではエラー・リプレイともに送信しない）
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://868c363edc229e35f5276d2c81417958@o4509133360791552.ingest.us.sentry.io/4509133362233349',
    integrations: [Sentry.replayIntegration()],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
  })
}

// 認証用Service Worker登録
registerAuthServiceWorker()

// セッションの復元とトークン連携を開始（オフラインでも保存済みのセッションから起動できる）
initAuth()

// 長期間再開されていない中断ダウンロードの中間データを破棄（ストレージ圧迫の防止）
cleanupStalePendingDownloads(STALE_DOWNLOAD_MAX_AGE_MS)
  .then((count) => {
    if (count > 0) console.log(`[Download] 期限切れの中断ダウンロード ${count} 件を削除しました`)
  })
  .catch((err: unknown) => console.error('[Download] 中断ダウンロードの掃除に失敗:', err))

// PWA Service Worker登録と自動更新
setupPwaUpdate()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    {/* <StrictMode> */}
    <App />
    {/* </StrictMode> */}
  </QueryClientProvider>,
)
